import React, { useState } from 'react'

function VehicleDescription({vehicle}) {
  // Feature 3: Lorries & Pick-up trucks show load capacity instead of seats
  const isLoadVehicle = vehicle.type === "Lorry" || vehicle.type === "Pickup";

  // Feature 2: optional distance-based cost estimate
  const [distance, setDistance] = useState("");
  const hasPricePerKm = vehicle.pricePerKm > 0;
  const estimatedCost =
    hasPricePerKm && distance
      ? (Number(distance) * Number(vehicle.pricePerKm)).toFixed(2)
      : null;

  return (

<div className="flex flex-col items-start max-w-4xl lg:w-[56rem] p-6 bg-white border border-gray-200 rounded-lg shadow-2xl sm:mx-5 gap-3 w-full">

<h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">Vehicle Description</h5>
<p className="font-normal text-gray-700 "><b>Name: </b>{vehicle.name}</p>
<p className="font-normal text-gray-700 "><b>Type: </b>{vehicle.type}</p>
<p className="font-normal text-gray-700 "><b>District: </b>{vehicle.district}</p>
<p className="font-normal text-gray-700 "><b>City: </b>{vehicle.city}</p>
{isLoadVehicle ? (
  <p className="font-normal text-gray-700 ">
    <b>Capacity: </b>
    {vehicle.maxLoadCapacity ? `${vehicle.maxLoadCapacity} kg` : "N/A"}
    {vehicle.cargoSize ? ` (${vehicle.cargoSize})` : ""}
  </p>
) : (
  <p className="font-normal text-gray-700 "><b>Available Seats: </b>{vehicle.availableSeats}</p>
)}
{hasPricePerKm && (
  <p className="font-normal text-gray-700 ">
    <b>Estimated Price per km: </b>LKR {vehicle.pricePerKm}
    <span className="text-xs text-gray-500"> (estimate only, final price may vary)</span>
  </p>
)}
<p className="font-normal text-gray-700 text-justify"><b>Description: </b>{vehicle.description}</p>

{hasPricePerKm && (
  <div className="w-full mt-2 p-4 bg-violet-50 border border-violet-100 rounded-lg">
    <p className="font-medium text-gray-800 mb-2">Estimate your trip cost</p>
    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
      <input
        type="text"
        inputMode="decimal"
        value={distance}
        onChange={(e) => {
          let v = e.target.value.replace(/[^\d.]/g, "");
          const parts = v.split(".");
          if (parts.length > 2) v = parts[0] + "." + parts.slice(1).join("");
          v = v.replace(/^0+(\d)/, "$1");
          setDistance(v);
        }}
        placeholder="Enter distance (km)"
        className="border border-[#a9b9e3] text-gray-900 text-sm rounded-lg focus:ring-[#6f48e5] focus:border-[#6f48e5] focus:outline-none p-2.5 w-full sm:w-56"
      />
      <p className="text-gray-800 font-semibold">
        {estimatedCost
          ? `≈ LKR ${estimatedCost}`
          : `× LKR ${vehicle.pricePerKm}/km`}
      </p>
    </div>
    <p className="text-xs text-gray-500 mt-2">
      This is an estimate only (distance × price per km) and not a final quote.
    </p>
  </div>
)}

</div>

  )
}

export default VehicleDescription
